import type { LC, LiveElement, PropsWithChildren } from '@use-gpu/live';
import type { PassEnv, PassResources } from './types';

import { memo } from '@use-gpu/live';

import { usePassContext } from '../providers/pass-provider';

export type EnvPassProps = {
  env?: Record<string, any>,
  then?: (env: PassEnv, targets: PassResources["targets"]) => LiveElement,
};

/** Env meta pass.
*/
export const EnvPass: LC<EnvPassProps> = memo((props: PropsWithChildren<EnvPassProps>) => {
  const {env, then} = props;

  const passContext = usePassContext();
  const {targets} = passContext;

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return then?.(env!, targets) ?? null;
}, 'EnvPass');
